import React, { useEffect, useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import Swal from "sweetalert2";

import api from "../../services/api";

import InputMask from "react-input-mask";

import DatePicker from "react-datepicker";

import { ptBR } from "date-fns/locale";

import { FiCalendar } from "react-icons/fi";

import "../Enfermeiro/enfermeiro.scss";

import "react-datepicker/dist/react-datepicker.css";

function Cadastro() {

  const navigate = useNavigate();
  const location = useLocation();

  const modo = location.state?.modo || "edicao";

  const marcador = location.state?.marcador || null;

  const editado_por = localStorage.getItem("clientID");

  const [datePickerOpen, setDatePickerOpen] = useState(false);

  const [lastValidDate, setLastValidDate] = useState(null);

  const [values, setValues] = useState({
    id: "",
    nome: "",
    cpf: "",
    data_nascimento: null,
    multiple_checks: false,
    editado_por,
  });






  const [originalValues, setOriginalValues] = useState({});
  const [isEditing, setIsEditing] = useState({
    nome: false,
    cpf: false,
    data_nascimento: false,
    multiple_checks: false,
  });
  const [cpfError, setCpfError] = useState("");
  const [cpfChecking, setCpfChecking] = useState(false);
  const [cpfVerificado, setCpfVerificado] = useState(false);

  const [loading, setLoading] = useState(false);

  // ===============================
  // MÁSCARA CPF
  // ===============================
  const formatCPF = (value) => {
    const cleaned = value.replace(/\D/g, "").slice(0, 11);

    return cleaned
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  };

  // ===============================
  // VALIDAÇÃO REAL CPF
  // ===============================
  const validarCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, "");

    if (cpf.length !== 11) return false;

    // bloqueia repetidos
    if (/^(\d)\1+$/.test(cpf)) return false;

    let soma = 0;
    let resto;

    // 1º dígito
    for (let i = 1; i <= 9; i++)
      soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);

    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10))) return false;

    soma = 0;

    // 2º dígito
    for (let i = 1; i <= 10; i++)
      soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);

    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11))) return false;

    return true;
  };


  // ===============================
  // VERIFICA SE O CPF JÁ EXISTE
  // ===============================
  const verificarCPFExistente = async (cpf) => {
    const cpfLimpo = cpf.replace(/\D/g, "");

    // Ainda não tem 11 números
    if (cpfLimpo.length !== 11) {
      setCpfError("");
      setCpfVerificado(false);
      setCpfChecking(false);
      return;
    }

    // CPF inválido
    if (!validarCPF(cpf)) {
      setCpfError("CPF inválido");
      setCpfVerificado(false);
      setCpfChecking(false);
      return;
    }

    try {
      setCpfChecking(true);
      setCpfVerificado(false);
      setCpfError("");

      // Consulta específica para verificar CPF
      const response = await api.get(
        `/enfermeiro/verificar-cpf/${cpfLimpo}`,
        {
          headers: {
            typo: localStorage.getItem("id"),
          },
        }
      );
      const data = response.data;

      console.log(
        "🔎 RETORNO VERIFICAÇÃO CPF:",
        data
      );

      // =====================================================
      // EDIÇÃO
      // =====================================================
      // Se o CPF encontrado pertence ao próprio enfermeiro,
      // ele continua sendo válido.
      if (
        data.existe &&
        modo === "edicao" &&
        String(data.enfermeiro?.id) === String(values.id)
      ) {
        setCpfError("");
        setCpfVerificado(true);
        return;
      }

      // =====================================================
      // CPF JÁ EXISTE
      // =====================================================
      if (data.existe) {
        setCpfError("CPF já está em uso");
        setCpfVerificado(false);
        return;
      }

      // =====================================================
      // CPF DISPONÍVEL
      // =====================================================
      setCpfError("");
      setCpfVerificado(true);

    } catch (error) {

      console.error("❌ ERRO COMPLETO CPF:", error);

      console.error(
        "❌ STATUS:",
        error.response?.status
      );

      console.error(
        "❌ DATA:",
        error.response?.data
      );

      console.error(
        "❌ URL:",
        error.config?.url
      );

      setCpfError(
        error.response?.data?.message ||
        "Não foi possível verificar o CPF."
      );

      setCpfVerificado(false);

    } finally {

      setCpfChecking(false);

    }
  };

  useEffect(() => {

    // ===============================
    // CADASTRO
    // ===============================
    if (modo === "cadastro") {

      const data = {
        id: "",
        nome: "",
        cpf: "",
        data_nascimento: null,
        multiple_checks: false,
        editado_por,
      };

      setValues(data);
      setOriginalValues(data);

      return;
    }

    // ===============================
    // EDIÇÃO
    // ===============================
    if (!marcador) {
      Swal.fire("Erro", "Dados não encontrados", "error");
      navigate(-1);
      return;
    }

    const data = {
      id: marcador?.id || "",
      nome: marcador?.nome || "",
      cpf: marcador?.cpf || "",
      data_nascimento: marcador?.data_nascimento
        ? new Date(marcador.data_nascimento)
        : null,
      multiple_checks: marcador?.multiple_checks || false,
      editado_por,
    };

    setValues(data);
    setOriginalValues(data);

  }, [modo, marcador, navigate, editado_por]);

  // ===============================
  // CONFIRMAR AO CLICAR
  // ===============================
  const handleFocus = async (field, e) => {
    if (isEditing[field]) return;

    // Remove foco somente quando existe um elemento real
    if (e?.target?.blur) {
      e.target.blur();
    }









  };


  // ===================================
  // CONFIRMAÇÃO EDITAR CAMPO
  // ===================================
  const confirmarEdicaoCampo = async (field, e = null) => {

    const nomesCampos = {
      nome: "Nome",
      cpf: "CPF",
      data_nascimento: "Data de Nascimento",
      multiple_checks: "Múltiplos Checklists",
    };

    // CADASTRO → não precisa confirmar
    if (modo === "cadastro") {
      return true;
    }

    // EDIÇÃO → campo já liberado
    if (isEditing[field]) {
      return true;
    }

    const result = await Swal.fire({

      icon: "question",

      iconColor: "#8fd3ff",

      title: "Editar campo",

      width: "430px",

      padding: "1.35rem",

      background: "#0b1722",

      color: "#e8f1f7",

      html: `
      <div class="swal-campo-edicao">

        <div class="swal-campo-edicao-description">
          Deseja liberar a edição deste campo?
        </div>


        <div class="swal-campo-edicao-field">

          <span class="swal-campo-edicao-label">
            Campo selecionado
          </span>

          <span class="swal-campo-edicao-value">
            ${nomesCampos[field] || field}
          </span>

        </div>


        <div class="swal-campo-edicao-hint">
          Você poderá alterar o valor após confirmar.
        </div>

      </div>
    `,

      showCancelButton: true,

      reverseButtons: true,

      confirmButtonText: "Confirmar",

      cancelButtonText: "Cancelar",

      confirmButtonColor: "#1686bd",

      cancelButtonColor: "#26394a",

      focusConfirm: false,

      customClass: {

        popup:
          "swal-campo-edicao-popup",

        title:
          "swal-campo-edicao-title",

        htmlContainer:
          "swal-campo-edicao-html",

        confirmButton:
          "swal-campo-edicao-confirm",

        cancelButton:
          "swal-campo-edicao-cancel",

        actions:
          "swal-campo-edicao-actions",

      },

      buttonsStyling: false,

      scrollbarPadding: false,

      heightAuto: false,

    });


    // Cancelou
    if (!result.isConfirmed) {
      return false;
    }




    // Libera o campo
    setIsEditing((prev) => ({
      ...prev,
      [field]: true,
    }));


    // Devolve o foco para o elemento
    if (e?.target?.focus) {

      setTimeout(() => {
        e.target.focus();
      }, 150);

    }


    return true;
  };







  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    // ==========================================
    // EDIÇÃO
    // ==========================================
    // No modo edição, só permite alterar
    // o campo depois que ele foi liberado.
    if (modo === "edicao" && !isEditing[name]) {
      return;
    }

    // ==========================================
    // CPF
    // ==========================================
    if (name === "cpf") {

      newValue = formatCPF(value);

      const cleaned = newValue.replace(/\D/g, "");

      // Toda alteração invalida a verificação anterior
      setCpfVerificado(false);

      if (cleaned.length === 11) {

        if (!validarCPF(newValue)) {

          setCpfError("CPF inválido");

        } else {

          setCpfError("");

          verificarCPFExistente(newValue);
        }

      } else {

        setCpfError("");
        setCpfChecking(false);

      }
    }

    // ==========================================
    // ATUALIZA VALOR
    // ==========================================
    setValues((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  // ===============================
  // VERIFICAR ALTERAÇÃO
  // ===============================
  const hasChanged =
    JSON.stringify(values) !== JSON.stringify(originalValues);

  // ===============================
  // SALVAR
  // ===============================
  const handleSubmit = async (e) => {
    e.preventDefault();

    // ==========================================
    // CADASTRO
    // ==========================================
    if (modo === "cadastro") {
      return handleCadastro(e);
    }

    // ==========================================
    // EDIÇÃO
    // ==========================================
    if (!hasChanged) {
      Swal.fire({
        title: "Aviso",
        text: "Nenhuma alteração foi feita.",
        icon: "info",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#0ea5e9",
      });

      return;
    }

    if (cpfError) {
      Swal.fire({
        title: "Erro",
        text: "CPF inválido.",
        icon: "error",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#ef4444",
      });

      return;
    }

    const confirm = await Swal.fire({

      title: "Deseja salvar a edição?",

      icon: "warning",
      iconColor: "#f59e0b",

      background: "#0b1722",
      color: "#e8f1f7",

      width: "460px",
      padding: "1.4rem",

      html: `
    <div class="swal-enfermeiro-salvar">

      <div class="swal-enfermeiro-salvar-description">
        Confirme para atualizar os dados do enfermeiro.
      </div>

    </div>
  `,

      showCancelButton: true,

      confirmButtonText: "Sim, salvar",
      cancelButtonText: "Cancelar",

      confirmButtonColor: "#1686bd",
      cancelButtonColor: "#26394a",

      reverseButtons: true,

      focusConfirm: false,

      customClass: {

        popup:
          "swal-enfermeiro-salvar-popup",

        title:
          "swal-enfermeiro-salvar-title",

        htmlContainer:
          "swal-enfermeiro-salvar-html",

        confirmButton:
          "swal-enfermeiro-salvar-confirm",

        cancelButton:
          "swal-enfermeiro-salvar-cancel",

        actions:
          "swal-enfermeiro-salvar-actions",

      },

      buttonsStyling: false,

      scrollbarPadding: false,

      heightAuto: false,

    });
    if (!confirm.isConfirmed) return;

    try {
      setLoading(true);

      const inicio = Date.now();

      /* LOADING */
      Swal.fire({
        title: "Salvando alterações...",

        background: "#0b1722",
        color: "#e8f1f7",

        width: "420px",
        padding: "1.35rem",

        showConfirmButton: false,

        allowOutsideClick: false,
        allowEscapeKey: false,

        scrollbarPadding: false,
        heightAuto: false,

        html: `
    <div class="swal-enfermeiro-salvando">

      <div class="swal-enfermeiro-salvando-spinner"></div>

      <div class="swal-enfermeiro-salvando-text">
        Aguarde enquanto atualizamos as informações.
      </div>

      <div class="swal-enfermeiro-salvando-subtext">
        Isso pode levar alguns segundos.
      </div>

    </div>
  `,

        customClass: {

          popup:
            "swal-enfermeiro-salvando-popup",

          title:
            "swal-enfermeiro-salvando-title",

          htmlContainer:
            "swal-enfermeiro-salvando-html",

        },

        buttonsStyling: false,
      });

      /* REQUISIÇÃO + TEMPO MÍNIMO RODANDO JUNTOS */
      await Promise.all([
        api.put(`/enfermeiro/${values.id}`, {
          ...values,
          editado_por,
        }),

        new Promise((resolve) => setTimeout(resolve, 2000)),
      ]);

      Swal.close();

      await Swal.fire({
        title: "Salvo com sucesso!",

        icon: "success",

        iconHtml: `
    <span class="swal-enfermeiro-sucesso-check">
      ✓
    </span>
  `,

        background: "#0b1722",
        color: "#e8f1f7",

        width: "400px",
        padding: "1.25rem",

        html: `
    <div class="swal-enfermeiro-sucesso">

      <div class="swal-enfermeiro-sucesso-message">
        As informações foram atualizadas.
      </div>

    </div>
  `,

        timer: 2200,

        timerProgressBar: true,

        showConfirmButton: false,

        scrollbarPadding: false,

        heightAuto: false,

        customClass: {
          popup:
            "swal-enfermeiro-sucesso-popup",

          title:
            "swal-enfermeiro-sucesso-title",

          htmlContainer:
            "swal-enfermeiro-sucesso-html",

          icon:
            "swal-enfermeiro-sucesso-icon",

          timerProgressBar:
            "swal-enfermeiro-sucesso-progress",
        },
      });
      navigate(-1);

    } catch (error) {
      Swal.close();

      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Erro ao salvar.",

        background: "#0f172a",
        color: "#fff",
      });

    } finally {
      setLoading(false);
    }
  };

  // ===============================
  // CADASTRO
  // ===============================
  const handleCadastro = async (e) => {
    e.preventDefault();

    // ==========================================
    // VALIDA CPF
    // ==========================================

    if (!values.cpf || values.cpf.replace(/[^\d]/g, "").length === 0) {
      await Swal.fire({
        icon: "warning",
        title: "CPF obrigatório",
        text: "O campo CPF não pode ficar vazio.",
        background: "#0f172a",
        color: "#fff",
      });

      return;
    }

    if (cpfError) {
      await Swal.fire({
        icon: "error",
        title: "CPF inválido",
        text: "Informe um CPF válido para continuar.",
        background: "#0f172a",
        color: "#fff",
      });

      return;
    }

    // ==========================================
    // VALIDA DATA DE NASCIMENTO
    // ==========================================

    if (!values.data_nascimento) {
      await Swal.fire({
        icon: "warning",
        title: "Data de nascimento obrigatória",
        text: "Informe a data de nascimento do profissional.",
        background: "#0f172a",
        color: "#fff",
      });

      return;
    }

    const dataNascimento = new Date(values.data_nascimento);

    // ==========================================
    // CALCULA IDADE
    // ==========================================

    const hoje = new Date();

    let idade =
      hoje.getFullYear() -
      dataNascimento.getFullYear();

    const mes =
      hoje.getMonth() -
      dataNascimento.getMonth();

    if (
      mes < 0 ||
      (mes === 0 &&
        hoje.getDate() < dataNascimento.getDate())
    ) {
      idade--;
    }

    // ==========================================
    // MENOR DE 18
    // ==========================================

    if (idade < 18) {
      await Swal.fire({
        icon: "warning",
        title: "Idade inválida",
        text: "O enfermeiro precisa ter no mínimo 18 anos.",
        background: "#ffffff",
        color: "#111827",
        showConfirmButton: false,
        timer: 2600,
        width: "320px",
        customClass: {
          popup: "custom-swal-clean",
        },
      });

      return;
    }

    // ==========================================
    // FORMATA DATA
    // ==========================================

    const dataFormatada =
      dataNascimento.toLocaleDateString("pt-BR");

    // ==========================================
    // CONFIRMAÇÃO CADASTRO
    // ==========================================

    const result = await Swal.fire({
      title: "Confirmar cadastro?",

      icon: "question",
      iconColor: "#8fd3ff",

      background: "#0b1722",
      color: "#e8f1f7",

      width: "500px",
      padding: "1.35rem",

      html: `
    <div class="swal-enfermeiro-cadastro">

      <div class="swal-enfermeiro-cadastro-description">
        Verifique as informações antes de cadastrar.
      </div>


      <div class="swal-enfermeiro-cadastro-data">

        <div class="swal-enfermeiro-cadastro-row">
          <span class="swal-enfermeiro-cadastro-label">
            Nome
          </span>

          <span class="swal-enfermeiro-cadastro-value">
            ${values.nome?.toUpperCase() || "-"}
          </span>
        </div>


        <div class="swal-enfermeiro-cadastro-row">
          <span class="swal-enfermeiro-cadastro-label">
            CPF
          </span>

          <span class="swal-enfermeiro-cadastro-value">
            ${values.cpf || "-"}
          </span>
        </div>


        <div class="swal-enfermeiro-cadastro-row">
          <span class="swal-enfermeiro-cadastro-label">
            Data de nascimento
          </span>

          <span class="swal-enfermeiro-cadastro-value">
            ${dataFormatada || "-"}
          </span>
        </div>


        <div class="swal-enfermeiro-cadastro-row">
          <span class="swal-enfermeiro-cadastro-label">
            Múltiplos checklists
          </span>

          <span class="swal-enfermeiro-cadastro-value">
            ${values.multiple_checks ? "Sim" : "Não"}
          </span>
        </div>

      </div>

    </div>
  `,

      showCancelButton: true,

      confirmButtonText: "Cadastrar",
      cancelButtonText: "Cancelar",

      reverseButtons: true,

      confirmButtonColor: "#1686bd",
      cancelButtonColor: "#26394a",

      buttonsStyling: false,

      scrollbarPadding: false,
      heightAuto: false,

      customClass: {
        popup:
          "swal-enfermeiro-cadastro-question-popup",

        title:
          "swal-enfermeiro-cadastro-title",

        htmlContainer:
          "swal-enfermeiro-cadastro-html",

        confirmButton:
          "swal-enfermeiro-cadastro-confirm",

        cancelButton:
          "swal-enfermeiro-cadastro-cancel",

        actions:
          "swal-enfermeiro-cadastro-actions",

        icon:
          "swal-enfermeiro-cadastro-icon",
      },
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);

      const dados = {
        nome: values.nome,
        cpf: values.cpf,
        data_nascimento: values.data_nascimento,
        multiple_checks: values.multiple_checks,

        ativo: true,

        id_cliente: localStorage.getItem("id"),
        criado_por: localStorage.getItem("clientID"),
      };

      // ==========================================
      // LOADING
      // ==========================================

   Swal.fire({
  title: "Cadastrando enfermeiro...",

  background: "#0b1722",
  color: "#e8f1f7",

  width: "420px",
  padding: "1.35rem",

  showConfirmButton: false,

  allowOutsideClick: false,
  allowEscapeKey: false,

  scrollbarPadding: false,
  heightAuto: false,

  html: `
    <div class="swal-enfermeiro-cadastrando">

      <div class="swal-enfermeiro-cadastrando-text">
        Aguarde enquanto salvamos os dados no sistema.
      </div>

      <div class="swal-enfermeiro-cadastrando-spinner"></div>

      <div class="swal-enfermeiro-cadastrando-subtext">
        Isso pode levar alguns segundos.
      </div>

    </div>
  `,

  customClass: {
    popup:
      "swal-enfermeiro-cadastrando-popup",

    title:
      "swal-enfermeiro-cadastrando-title",

    htmlContainer:
      "swal-enfermeiro-cadastrando-html",
  },

  buttonsStyling: false,
});

      const inicio = Date.now();

      // ==========================================
      // CADASTRA NO BACKEND
      // ==========================================

      await api.post("/enfermeiro", dados);

      // ==========================================
      // TEMPO MÍNIMO DO LOADING
      // ==========================================

      const tempoMinimo = 2500;
      const tempoPassado = Date.now() - inicio;

      if (tempoPassado < tempoMinimo) {
        await new Promise((resolve) =>
          setTimeout(
            resolve,
            tempoMinimo - tempoPassado
          )
        );
      }

      Swal.close();

      // ==========================================
      // SUCESSO
      // ==========================================

     await Swal.fire({
  title: "Cadastro realizado!",

  icon: "success",

  iconHtml: `
    <span class="swal-enfermeiro-cadastro-success-check">
      ✓
    </span>
  `,

  background: "#0b1722",
  color: "#e8f1f7",

  width: "400px",
  padding: "1.25rem",

  html: `
    <div class="swal-enfermeiro-cadastro-success">

      <div class="swal-enfermeiro-cadastro-success-message">
        Enfermeiro cadastrado com sucesso.
      </div>

    </div>
  `,

  timer: 2200,

  timerProgressBar: true,

  showConfirmButton: false,

  scrollbarPadding: false,

  heightAuto: false,

  customClass: {
    popup:
      "swal-enfermeiro-cadastro-success-popup",

    title:
      "swal-enfermeiro-cadastro-success-title",

    htmlContainer:
      "swal-enfermeiro-cadastro-success-html",

    icon:
      "swal-enfermeiro-cadastro-success-icon",

    timerProgressBar:
      "swal-enfermeiro-cadastro-success-progress",
  },

  buttonsStyling: false,
});

      navigate(-1);

    } catch (error) {

      Swal.close();

      // ==========================================
      // CPF DUPLICADO
      // ==========================================

      if (error?.response?.status === 409) {

        await Swal.fire({
          icon: "warning",
          title: "Cadastro duplicado",
          text: "CPF já cadastrado no sistema!",
          confirmButtonText: "Entendi",

          background: "#0f172a",
          color: "#fff",

          customClass: {
            popup: "swal-dark",
          },
        });

        return;
      }

      // ==========================================
      // ERRO GERAL
      // ==========================================

      await Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Erro ao cadastrar enfermeiro.",

        background: "#0f172a",
        color: "#fff",

        customClass: {
          popup: "swal-dark",
        },
      });

    } finally {
      setLoading(false);
    }
  };







  if (modo === "edicao" && !marcador) return null;

  // ===============================
  // BOTÃO SALVAR / CADASTRAR
  // ===============================

  const canSubmit =
    modo === "cadastro"
      ? (
        values.nome.trim() !== "" &&
        values.cpf.replace(/[^\d]/g, "").length === 11 &&
        values.data_nascimento instanceof Date &&
        !isNaN(values.data_nascimento) &&
        !cpfError &&
        !cpfChecking &&
        cpfVerificado
      )
      : (
        hasChanged &&
        !cpfError &&
        !cpfChecking &&
        (
          !isEditing.cpf ||
          cpfVerificado
        )
      );

  return (

    <div className="cadastro-enfermeiro-container">

      <div className="cadastro-enfermeiro-card">

        {/* =====================================================
          HEADER
      ===================================================== */}

        <div className="cadastro-enfermeiro-header">

          <div className="cadastro-header-content">

            <div className="cadastro-header-line"></div>

            <div>

              <h4 className="cadastro-enfermeiro-title">

                {modo === "cadastro"
                  ? "Cadastro de Enfermeiro"
                  : "Editar Enfermeiro"}

              </h4>

              <span className="cadastro-enfermeiro-subtitle">

                {modo === "cadastro"
                  ? "Preencha os dados para cadastrar um novo enfermeiro."
                  : "Altere os dados necessários do enfermeiro."}

              </span>

            </div>

          </div>


          {/* BOTÃO FECHAR */}

          <button
            type="button"
            className="cadastro-close-btn"
            onClick={() => navigate(-1)}
            title="Fechar"
          >

            <span>×</span>

          </button>

        </div>


        {/* =====================================================
          BODY
      ===================================================== */}

        <div className="cadastro-enfermeiro-body">

          <form onSubmit={handleSubmit}>

            {/* =====================================================
              CAMPOS
          ===================================================== */}

            <div className="cadastro-fields">


              {/* =================================================
                NOME
            ================================================= */}

              <div className="cadastro-field">

                <label className="cadastro-label">
                  Nome
                  <span className="required">*</span>
                </label>


                <input
                  type="text"
                  name="nome"
                  value={values.nome}
                  onChange={handleChange}

                  onClick={async (e) => {

                    if (modo !== "edicao") {
                      return;
                    }

                    if (isEditing.nome) {
                      return;
                    }

                    await confirmarEdicaoCampo(
                      "nome",
                      e
                    );

                  }}

                  readOnly={
                    modo === "edicao" &&
                    !isEditing.nome
                  }

                  required
                  maxLength={30}

                  className="cadastro-input"

                  placeholder="Digite o nome completo"

                  autoComplete="off"
                />


                <div className="cadastro-input-footer">

                  <span>
                    Nome do enfermeiro
                  </span>

                  <span>
                    {(values.nome || "").length}/30
                  </span>

                </div>

              </div>


              {/* =================================================
                CPF
            ================================================= */}

              <div className="cadastro-field">

                <label className="cadastro-label">
                  CPF
                  <span className="required">*</span>
                </label>

                <InputMask

                  mask="999.999.999-99"

                  name="cpf"

                  placeholder="000.000.000-00"

                  className={`cadastro-input ${cpfError
                    ? "cadastro-input-error"
                    : ""
                    }`}

                  value={values.cpf || ""}

                  onChange={handleChange}

                  readOnly={
                    modo === "edicao" &&
                    !isEditing.cpf
                  }

                  onClick={async (e) => {

                    if (modo !== "edicao") {
                      return;
                    }

                    if (isEditing.cpf) {
                      return;
                    }

                    await confirmarEdicaoCampo(
                      "cpf",
                      e
                    );

                  }}

                  autoComplete="off"

                />

                {cpfChecking && (

                  <div className="cadastro-help">
                    Verificando CPF...
                  </div>

                )}

                {!cpfChecking && cpfError && (

                  <div className="cadastro-error-message">
                    {cpfError}
                  </div>

                )}

                {!cpfChecking &&
                  !cpfError &&
                  !cpfVerificado && (

                    <div className="cadastro-help">
                      Informe o CPF do enfermeiro.
                    </div>

                  )}

                {!cpfChecking &&
                  !cpfError &&
                  cpfVerificado && (

                    <div className="cadastro-help">
                      CPF disponível.
                    </div>

                  )}

              </div>


              {/* =================================================
                DATA DE NASCIMENTO
            ================================================= */}

              <div className="cadastro-field">

                <label className="cadastro-label">

                  Data de Nascimento

                  <span className="required">
                    *
                  </span>

                </label>


                <div className="custom-date-wrapper">


                  <DatePicker

                    locale={ptBR}

                    placeholderText="DD/MM/AAAA"

                    maxDate={
                      new Date(
                        new Date().setFullYear(
                          new Date().getFullYear() - 18
                        )
                      )
                    }

                    popperPlacement="bottom-start"

                    portalId="root"

                    selected={
                      values.data_nascimento || null
                    }

                    open={datePickerOpen}

                    onInputClick={async () => {

                      const autorizado =
                        await confirmarEdicaoCampo("data_nascimento");

                      if (!autorizado) {
                        return;
                      }

                      setTimeout(() => {
                        setDatePickerOpen(true);
                      }, 100);

                    }}

                    onChange={(date) => {

                      if (
                        modo === "edicao" &&
                        !isEditing.data_nascimento
                      ) {
                        return;
                      }

                      setLastValidDate(date);

                      handleChange({
                        target: {
                          name: "data_nascimento",
                          value: date,
                        },
                      });

                      setDatePickerOpen(false);

                    }}

                    onCalendarClose={() => {

                      setDatePickerOpen(false);

                      if (
                        !values.data_nascimento &&
                        lastValidDate
                      ) {

                        handleChange({
                          target: {
                            name: "data_nascimento",
                            value: lastValidDate,
                          },
                        });

                      }

                    }}

                    dateFormat="dd/MM/yyyy"

                    customInput={

                      <InputMask

                        mask="99/99/9999"

                        placeholder="DD/MM/AAAA"

                        className="cadastro-input custom-date-input"

                        readOnly={
                          modo === "edicao" &&
                          !isEditing.data_nascimento
                        }

                      />

                    }

                    showMonthDropdown

                    showYearDropdown

                    dropdownMode="select"

                    autoComplete="off"

                  />


                  {/* ÍCONE */}

                  <FiCalendar
                    className="custom-date-icon"
                  />


                  {/* LIMPAR DATA */}

                  {values.data_nascimento && (

                    <button

                      type="button"

                      className="clear-date-btn"

                      disabled={
                        modo === "edicao" &&
                        !isEditing.data_nascimento
                      }

                      onClick={() => {

                        if (
                          modo === "edicao" &&
                          !isEditing.data_nascimento
                        ) {
                          return;
                        }

                        handleChange({
                          target: {
                            name: "data_nascimento",
                            value: null,
                          },
                        });

                      }}

                    >
                      ×
                    </button>

                  )}

                </div>


                <div className="cadastro-help">

                  O enfermeiro deve ter 18 anos ou mais.

                </div>

              </div>


              {/* =================================================
                OPÇÕES / MÚLTIPLOS CHECKLISTS
            ================================================= */}

              <div className="cadastro-field">

                <label className="cadastro-label">
                  Opções
                </label>


                <div className="cadastro-option-card">


                  <label

                    className="cadastro-checkbox"

                    onClick={async (e) => {

                      // CADASTRO
                      if (modo === "cadastro") {
                        return;
                      }


                      // EDIÇÃO - já liberado
                      if (isEditing.multiple_checks) {
                        return;
                      }


                      /*
                       * Impede o checkbox de alterar
                       * antes da confirmação.
                       */
                      e.preventDefault();


                      const autorizado =
                        await confirmarEdicaoCampo(
                          "multiple_checks",
                          e
                        );


                      if (!autorizado) {
                        return;
                      }

                    }}

                  >


                    <input

                      type="checkbox"

                      name="multiple_checks"

                      checked={
                        values.multiple_checks || false
                      }

                      onChange={handleChange}

                      disabled={false}

                    />


                    <span className="cadastro-checkmark">

                      <span>
                        ✓
                      </span>

                    </span>


                    <span className="cadastro-checkbox-text">

                      <strong>
                        Múltiplos Checklists
                      </strong>

                      <small>
                        Permitir que o enfermeiro utilize múltiplos checklists.
                      </small>

                    </span>


                  </label>

                </div>

              </div>


            </div>


            {/* =====================================================
              FOOTER / BOTÕES
          ===================================================== */}

            <div className="cadastro-enfermeiro-footer">


              <button

                type="button"

                className="
                cadastro-btn
                cadastro-btn-cancelar
              "

                onClick={() => navigate(-1)}

              >
                Cancelar
              </button>


              <button

                type="submit"

                className="
                cadastro-btn
                cadastro-btn-salvar
              "

                disabled={!canSubmit}

              >

                {modo === "cadastro"
                  ? "Cadastrar"
                  : "Salvar alterações"}

              </button>


            </div>


          </form>

        </div>

      </div>

    </div>

  );
}

export default Cadastro;
